import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { TokenService } from "../../chung-thu-so/TokenService";
import { RegisterInvoiceService } from "../../../../service/invoice/RegisterInvoiceService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import {UserPermisionDataAppService} from "./UserPermisionDataAppService";
import moment from "moment";
import { ToastService } from "../../../../AppToast";
import { UserService } from "./UserService";
import { CONSTANT } from "../../../../Constant";

export const PermissionDialog = (props: PermissionDialogProps) => {
  const { display, hide, selectedItems: selectedUsers } = props;
  const [viewOtherInvoice, setViewOtherInvoice] = useState(false);
  const [editOtherInvoice, setEditOtherInvoice] = useState(false);
  const [deleteOtherInvoice, setDeleteOtherInvoice] = useState(false);
  const [user, setUser] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [tokens, setTokens] = useState([]);
  const [selectedTokens, setSelectedTokens] = useState([]);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [selectedRegisterInvoices, setSelectedRegisterInvoices] = useState([]);
  const API_ERROR = CONSTANT.API_ERROR;
  const groupToken = 'Token';
  const groupRegisterInvoice = 'RegisterInvoice';
  const groupActionData = 'ActionData';

  useEffect(() => {
    let curUser;
    if (Array.isArray(selectedUsers)) {
      let totalItems = user ? user.length : 0;
      if (totalItems === 1) {
        curUser = selectedUsers[0];
      }
    } else if (selectedUsers && Object.keys(selectedUsers)) {
      curUser = selectedUsers;
    }

    setUser(curUser);
    setViewOtherInvoice(curUser?.viewOtherInvoice);
    setEditOtherInvoice(curUser?.editOtherInvoice);
    setDeleteOtherInvoice(curUser?.deleteOtherInvoice);
  }, [selectedUsers]);

  useEffect(() => {
    if(display){
      UserPermisionDataAppService.getList({userId: user.id, MaxResultCount: 1000}).then(({items}) => {
          getTokens(items);
          getRegisterInvoices(items);
      });
    }
  }, [display]);

  const seletedRegisterInvoice = (userPermisionData, registerInvoises) => {
    const registerInvoices = userPermisionData.filter(t => t.group === groupRegisterInvoice);
    const registerInvoicechoose = [];
    registerInvoices.forEach(element => {
      var registerInvoiceMap = registerInvoises.filter(t => t.id === element.recordId);
      registerInvoiceMap.forEach(item => {
        registerInvoicechoose.push(item);
      });
    });
    
    setSelectedRegisterInvoices(registerInvoicechoose);
  }

  const seletedToken = (userPermisionData, tokens) => {
    const tokenData = userPermisionData.filter(t => t.group === groupToken);
    const tokenchoose = [];
    tokenData.forEach(element => {
      var tokenMap = tokens.filter(t => t.id === element.recordId);
      tokenMap.forEach(item => {
        tokenchoose.push(item);
      });
    });
    setSelectedTokens(tokenchoose);
  }

  const updateUserPermission = (key, value) => {
    setUser({ ...user, [key]: value });
  };

  const onShow = () => {};

  const getTokens = (userPermisionData) => {
    return new Promise<any>((resolve) => {
        TokenService.getPermissionList({Used: true, MaxResultCount: 1000}).then(({items}) => {
          setTokens(items);
          resolve(items);
          seletedToken(userPermisionData, items);
        }).catch(() => {
          resolve(tokens);
        });
    });
  }

  const getRegisterInvoices = (userPermisionData) => {
    return new Promise<any>((resolve) => {
      let params = {maxResultCount: 1000}
      RegisterInvoiceService.getList(params).then(({items}) => {
          setRegisterInvoices(items);
          seletedRegisterInvoice(userPermisionData, items);
          resolve(items);
        }).catch(() => {
          resolve(tokens);
        });
    });
  }

  /**
   * Hàm lưu thông tin ở các tab (theo nghiệp vụ)
   * @resolve đóng popup thực hiện thông báo thành công + đóng popup
   * @exception 1 trong 3 hàm lỗi thì sẽ k thực hiện thông báo thành công + đóng popup
   * @ref https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/all
   */
  const saveAll = () => {
    Promise.all([
        saveUserPermisionData(),
        saveUser(),
    ]).then((data) => {
      ToastService.success();
      hide();
    })
  }

  /**
   * Hàm lưu chứng thư số
   * @returns 
   * @exception throw exception nếu gọi api lỗi
   */
  const saveUserPermisionData = () => {
    const userPermisionData = {
      userId: user.id,
      userPermisionData: [
        ...createDataTokens(),
        ...createDataRegisterInvoice(),
        ...createDataActionData()
      ]
    };
    return UserPermisionDataAppService.create(userPermisionData).then(res => {}, error => {
      throw new Error(API_ERROR)
    });
  }
  const createDataTokens = () =>{ 
    const userPermisionToken = [];

    selectedTokens.forEach((token) => {

      userPermisionToken.push({
        userId: user.id,
        recordId: token.id,
        functionName: groupToken,
        group: groupToken,
      });

    });
    return userPermisionToken;
  }
  const createDataActionData = () =>{
    const userActionData = [];
    userActionData.push({
      userId: user.id,
      recordId: user.id,
      functionName: groupActionData,
      group: groupActionData,
      subAction: 'viewOtherInvoice',
      canAction: viewOtherInvoice
    });
    userActionData.push({
      userId: user.id,
      recordId: user.id,
      functionName: groupActionData,
      group: groupActionData,
      subAction: 'editOtherInvoice',
      canAction: editOtherInvoice
    });
    userActionData.push({
      userId: user.id,
      recordId: user.id,
      functionName: groupActionData,
      group: groupActionData,
      subAction: 'deleteOtherInvoice',
      canAction: deleteOtherInvoice
    });

    return userActionData;
  }

  const createDataRegisterInvoice = () =>{ 
    const userRegisterInvoices = [];

    selectedRegisterInvoices.forEach((registerInvoice) => {

      userRegisterInvoices.push({
        userId: user.id,
        recordId: registerInvoice.id,
        functionName: groupRegisterInvoice,
        group: groupRegisterInvoice,
      });

    });
    return userRegisterInvoices;
  }

  /**
   * Hàm lưu quyền truy cập hóa đơn theo NSD
   * @returns 
   * @exception throw exception nếu gọi api lỗi
   */
  const saveUser = () =>{
    let payload = {...user, ...{
      viewOtherInvoice: viewOtherInvoice,
      editOtherInvoice: editOtherInvoice,
      deleteOtherInvoice: deleteOtherInvoice,
    }}

    /**
     * Gọi api update user
     * @Ok Không làm gì cả
     * @exception Thông báo đã được xử lý chung cho các api gọi ở axios
     *            Trigger thêm 1 exception để reject Promise gọi gộp api
     */
    return UserService.update(user.id, payload).then(res => {}, error => {
      throw new Error(API_ERROR)
    });
  }

  return (
    <Dialog header="Phân quyền" visible={display} maximized={true} position="top" onHide={() => hide()} onShow={onShow}>
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Chứng thư số">
          <div className="iam-data-table" style={{height: `calc(100vh - ${250}px)`}}>
            <DataTable value={tokens}  selection={selectedTokens} onSelectionChange={e => setSelectedTokens(e.value)}
													 showGridlines stripedRows size="small" responsiveLayout="scroll"
													 scrollable scrollHeight="flex"
													 dataKey="id"
                           >
              <Column selectionMode="multiple" style={{minWidth: '3em', maxWidth: '3rem', justifyContent: 'center'}}></Column>
              <Column field="vender" header="Tên đơn vị cấp chứng thư số" style={{minWidth: 200}}></Column>
              <Column field="subjectName" header="Tên chủ sở hữu" style={{width: 180}}></Column>
              <Column field="serialNumber" header="Serial chứng thư" style={{width: 180}}></Column>
              <Column field="dateFrom" header="Ngày có hiệu lực" style={{width: 140}}
                body={(rowData) => moment(rowData.dateFrom).format(CONSTANT.DD_MM_YYYY)}></Column>
              <Column field="expireDate" header="Ngày hết hạn" style={{width: 130}}
                  body={(rowData) => moment(rowData.expireDate).format(CONSTANT.DD_MM_YYYY)}></Column>
            </DataTable>
          </div>
        </TabPanel>
        <TabPanel header="Ký hiệu hóa đơn NĐ123">
        <div className="iam-data-table" style={{height: `calc(100vh - ${250}px)`, width: '800px'}}>
            <DataTable value={registerInvoices} selection={selectedRegisterInvoices} onSelectionChange={e => setSelectedRegisterInvoices(e.value)}
													 showGridlines stripedRows size="small" responsiveLayout="scroll"
													 scrollable scrollHeight="flex"
													 dataKey="id"
                        >
              <Column selectionMode="multiple" style={{minWidth: '3em', maxWidth: '3rem', justifyContent: 'center'}}></Column>
              <Column field="symbolCode" header="Ký hiệu" style={{width: '160px'}}></Column>
              <Column field="invoiceTypeName" header="Loại hoá đơn" style={{width: '400px'}}></Column>
              <Column field="signOnly" header="Hình thức ký gửi" style={{width: '140px'}}
                body={(rowData) => rowData.signOnly ? "Ký gửi Bảng tổng hợp" : "Ký gửi ngay CQT"}></Column>
            </DataTable>
          </div>
        </TabPanel>
        <TabPanel header="Quyền truy cập hóa đơn theo Người sử dụng">
          <div className="field-checkbox">
            <Checkbox
              inputId="view"
              checked={viewOtherInvoice}
              onChange={(e) => {
                updateUserPermission("viewOtherInvoice", e.checked);
                setViewOtherInvoice(e.checked);
              }}
            />
            <label htmlFor="view">Xem chứng từ của NSD khác</label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId="edit"
              checked={editOtherInvoice}
              onChange={(e) => {
                updateUserPermission("editOtherInvoice", e.checked);
                setEditOtherInvoice(e.checked);
              }}
            />
            <label htmlFor="edit">Sửa chứng từ của NSD khác</label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId="delete"
              checked={deleteOtherInvoice}
              onChange={(e) => {
                updateUserPermission("deleteOtherInvoice", e.checked);
                setDeleteOtherInvoice(e.checked);
              }}
            />
            <label htmlFor="delete">Xóa chứng từ của NSD khác</label>
          </div>
        </TabPanel>
      </TabView>

      <div className="flex justify-content-center">
        <Button label="Đóng" icon="pi pi-times" onClick={() => hide()} className="p-button-text p-button-sm" />
        <Button label="Lưu" icon="pi pi-check" onClick={saveAll} loading={submitting} className="p-button-sm" />
      </div>
    </Dialog>
  );
};

interface PermissionDialogProps {
  display?: boolean;
  hide?: any;
  selectedItems?: any[];
}
